import { defineComponent as S, computed as l, createBlock as w, createElementBlock as b, openBlock as d, unref as u, withCtx as c, createVNode as v, createElementVNode as o, toDisplayString as m } from "vue";
import { ScalarListbox as h, ScalarButton as y } from "@scalar/components";
import { ScalarIconCaretDown as V } from "@scalar/icons";
const k = { class: "overflow-x-auto" }, B = {
  key: 1,
  class: "text-c-1 flex h-auto w-full items-center gap-0.75 rounded-b-lg px-3 py-1.5 text-base leading-[20px] whitespace-nowrap"
}, C = { class: "overflow-x-auto" }, N = /* @__PURE__ */ S({
  __name: "Selector",
  props: {
    xSelectedServer: {},
    servers: {},
    target: {}
  },
  emits: ["update:modelValue"],
  setup(r, { expose: p, emit: f }) {
    const x = f, a = l(
      () => r.servers.map((e) => ({
        id: e.url,
        label: e.url
      }))
    ), i = l(() => r.servers.find((e) => e.url === r.xSelectedServer)), s = l(
      () => {
        var e, t;
        return ((t = (e = i.value) == null ? void 0 : e.url) == null ? void 0 : t.replace(/\/$/, "")) || "";
      }
    ), n = l({
      get: () => {
        if (r.xSelectedServer && a.value.length > 0)
          return a.value.find((e) => e.id === r.xSelectedServer);
      },
      set: (e) => {
        e && x("update:modelValue", e.id);
      }
    });
    return p({
      server: i,
      servers: r.servers,
      serverUrlWithoutTrailingSlash: s,
      serverOptions: a,
      selectedServer: n
    }), (e, t) => a.value.length > 1 ? (d(), w(u(h), {
      key: 0,
      ref: "elem",
      modelValue: n.value,
      "onUpdate:modelValue": t[0] || (t[0] = (g) => n.value = g),
      class: "group",
      options: a.value,
      placement: "bottom-start",
      resize: "",
      target: e.target
    }, {
      default: c(() => [
        v(u(y), {
          class: "bg-b-1 text-c-1 h-auto w-full justify-start gap-1.5 overflow-x-auto rounded-t-none rounded-b-lg px-3 py-1.5 text-base font-normal whitespace-nowrap -outline-offset-1",
          variant: "ghost"
        }, {
          default: c(() => [
            t[1] || (t[1] = o("span", { class: "sr-only" }, "Server:", -1)),
            o("span", k, m(s.value), 1),
            v(u(V), {
              class: "text-c-2 ui-open:rotate-180 mt-0.25 size-3 transition-transform duration-100",
              weight: "bold"
            })
          ]),
          _: 1,
          __: [1]
        })
      ]),
      _: 1
    }, 8, ["modelValue", "options", "target"])) : (d(), b("div", B, [
      t[2] || (t[2] = o("span", { class: "sr-only" }, "Server:", -1)),
      o("span", C, m(s.value), 1)
    ]));
  }
});
export {
  N as default
};
